import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import { Global } from '../services/Global';
import { APIS } from '../services/Config';
import ApiService from '../services/Api';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class AditionalDataPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: FormFields.aditional_data,
            next_active: false,
            total_ingresos_familiare: 0,
            status_hijos: false,
            paises: [],
            can_edit: true
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {

            let _nfields = _root.state.fields;

            _root.setState({
                can_edit: true,
                fields: _nfields
            }, () => {
                _root.setState({
                    program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                    next_active: Global.formValidation('aditional_data', _root.state.fields, _root.props.pro)
                }, () => {
                    if (_root.props.pro.tipoIngresos === '3') {
                        _root.props.pro.ingresosProfesionales = 0;
                        _root.props.pro.ingresosOtros = 0;
                        _root.props.pro.ingresosFamiliaresMes = 0;
                        _root.props.pro.egresosFamiliaresMes = 0;
                        if (document.getElementById('ingresosProfesionales')) { document.getElementById('ingresosProfesionales').value = 0 };
                        if (document.getElementById('ingresosOtros')) { document.getElementById('ingresosOtros').value = 0 };
                        if (document.getElementById('ingresosFamiliaresMes')) { document.getElementById('ingresosFamiliaresMes').value = 0 };
                        if (document.getElementById('egresosFamiliaresMes')) { document.getElementById('egresosFamiliaresMes').value = 0 };
                        _root.setState({
                            next_active: true
                        });
                    }
                });
            });

        }

    }

    onChange = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        //ingresosProfesionales ingresosOtros
        if (_target.name === 'ingresosProfesionales' || _target.name === 'ingresosOtros') {
            if (_target.value < 0.00) { _target.value = '' }
            const validated = _target.value.match(/^(\d*\.{0,1}\d{0,2}$)/);
            if (!validated) {
                return;
            }
        }
        _root.props.pro[_target.name] = _target.value;

        //la suma se realiza despues de la asignacion de valores
        var _n1 = Number(_root.props.pro.ingresosProfesionales);
        var _n2 = Number(_root.props.pro.ingresosOtros);
        _root.props.pro.ingresosFamiliaresMes = _n1 + _n2;
        // _root.setState({});
        _root.checkFields(Global.checkFormData(_target, _root.state, 'aditional_data', _root.props.pro), 'onchange');
    }

    onKeyPress = e => {
        e = e || window.event;
        var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        var charStr = String.fromCharCode(charCode);
        if (!charStr.match(/^[0-9]+$/))
            e.preventDefault();
    }

    onKeyPressInputValidate = param => (event) => {
        let _target = event.target;

        switch (_target.name) {
            case '':
                break;
            default:
                Global.onKeyPressInputValidate(event, param);
                break;
        }
    }


    onBlur = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        _root.checkFields(Global.checkFormData(_target, _root.state, 'aditional_data', _root.props.pro), 'onblur');
    }

    checkFields(state, evt) {
        let _root = this;
        let _formValidation = Global.formValidation('aditional_data', state.fields, _root.props.pro);

        _root.setState({
            fields: state.fields,
            next_active: _formValidation
        }, () => {
            if (evt === 'onblur') {
                if (_formValidation) {
                    localStorage.setItem('app_fd', Tools.cryptrData(JSON.stringify(state.fields)));
                }
            }
        });


        if (_root.props.pro.tipoIngresos === '3') {
            _root.props.pro.ingresosProfesionales = 0;
            _root.props.pro.ingresosOtros = 0;
            _root.props.pro.ingresosFamiliaresMes = 0;
            _root.props.pro.egresosFamiliaresMes = 0;
            document.getElementById('ingresosProfesionales').value = 0;
            document.getElementById('ingresosOtros').value = 0;
            document.getElementById('ingresosFamiliaresMes').value = 0;
            document.getElementById('egresosFamiliaresMes').value = 0;
            _root.setState({
                next_active: true
            });
        }

    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        Tools.showPreloader();
        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/datos-adicionales'));

        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);
        ApiService.postData(`${APIS.submission}`, _root.props.pro)
            .then(res => {
                Tools.hidePreloader();
                if (_root.props.pro.idSubmissionType === 3 || _root.props.pro.idSubmissionType === 4) {
                    _root.props.navigate('/informacion-laboral');
                } else {
                    _root.props.navigate('/datos-conyuge');
                }
            })
            .catch(err => {
                Tools.hidePreloader();
                console.log(err);
            });
    }

    render() {

        const {
            program_selected,
            next_active,
            can_edit
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <div className="container">
                <div className="row app-layout-main">
                    <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                        {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'1'} form={program_selected.form} /> : <></>}
                    </div>
                    <div className="col-md-9 right-side-dashboard">
                        <TopProcessComponent porcent="5" />
                        <div className="row content-dashboard">
                            <div className="col-sm-12">
                                <div className="row pt-3 pb-3">
                                    <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/datos-generales" /></div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className="form-group pb-2">
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-6">
                                        <h5><strong>Ingresos Económicos</strong></h5>
                                    </div>
                                </div>
                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2 gri">
                                            <label htmlFor="tipoIngresos" className="pb-2 w-100">Ingresos como profesionales S/. <span className="text-danger">*</span></label>
                                            <div className="input-tg-inline">

                                                <select className="form-control" id="tipoIngresos" name="tipoIngresos" value={this.props.pro.tipoIngresos} onChange={this.onChange} onBlur={this.onBlur}>
                                                    <option value={-1}>Selecciona una opción</option>
                                                    {
                                                        this.props.glo.tiposIngreso && this.props.glo.tiposIngreso.map((item, i) => (
                                                            <option key={(item.id) + 'pa'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <input type="number" nim="0" pattern="[0-9]*" className="form-control" id="ingresosProfesionales" name="ingresosProfesionales" value={this.props.pro.ingresosProfesionales} onKeyPress={this.onKeyPress} onChange={this.onChange} onBlur={this.onBlur} />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="ingresosOtros" className="pb-2">Otros S/.</label>
                                            <input type="number" nim="0" pattern="[0-9]*" className="form-control" id="ingresosOtros" name="ingresosOtros" aria-describedby="nameHelp" value={this.props.pro.ingresosOtros} onKeyPress={this.onKeyPress} onChange={this.onChange} onBlur={this.onBlur} />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="ingresosFamiliaresMes" className="pb-2">Total Ingresos Mes <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" id="ingresosFamiliaresMes" name="ingresosFamiliaresMes" aria-describedby="nameHelp" value={this.props.pro.ingresosFamiliaresMes} disabled />
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group pb-2">
                                            <label htmlFor="egresosFamiliaresMes" className="pb-2">Total Gastos Mes <span className="text-danger">*</span></label>
                                            {
                                                (can_edit)
                                                    ?
                                                    <input type="number" min="0" pattern="[0-9]*"
                                                        className="form-control" id="egresosFamiliaresMes"
                                                        name="egresosFamiliaresMes" aria-describedby="nameHelp"
                                                        value={this.props.pro.egresosFamiliaresMes}
                                                        onKeyPress={this.onKeyPress} onChange={this.onChange}
                                                        onBlur={this.onBlur} />
                                                    :
                                                    <input type="number" min="0" pattern="[0-9]*" className="form-control" id="egresosFamiliaresMes" name="egresosFamiliaresMes" aria-describedby="nameHelp" value={this.props.pro.egresosFamiliaresMes} disabled readOnly />
                                            }
                                            <div className="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4"></div>
                                </div>


                                <div className="row pt-2 pb-2">
                                    <div className="col-sm-12 col-md-4">
                                        <small className="text-danger">*Obligatorio</small>
                                    </div>
                                    <div className="col-sm-12 col-md-4"></div>
                                    <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                        {
                                            (can_edit)
                                                ?
                                                <button className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'}
                                                    onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                                :
                                                <button className="btn btn-primary btn-style-4"
                                                    onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AditionalDataPage);